import { useId } from "react";
import { Angle, Maximize2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useCustomArtStore } from "../../../stores/custom-art-store";
import { dispatchScheduleEvent } from "../../../lib/schedule-history/dispatch";
import { PlacementNumberField } from "../developer-section/PlacementNumberField";
import { MetadataElementLayout } from "../developer-section/MetadataElementLayout";

export function ArtTransformControls() {
  const { t } = useTranslation();
  const id = useId();
  const art = useCustomArtStore(state => state.layers.find(layer => layer.imageId === state.selectedId));
  const transform = art?.transform;
  const fields = [
    { key: "x", label: t("art.x"), value: transform?.x ?? 0 },
    { key: "y", label: t("art.y"), value: transform?.y ?? 0 },
    { key: "size", label: t("art.size"), value: (transform?.scaleX ?? 1) * 100 },
    { key: "rotation", label: t("art.rotation"), value: transform?.rotation ?? 0 },
  ] as const;

  return (
    <MetadataElementLayout fields={fields.map(({ key, label, value }) => ({
      key,
      content: <PlacementNumberField id={`${id}-${key}`} value={Math.round(value * 100) / 100}
        label={key === "size" ? <Maximize2 className="size-3.5" /> : key === "rotation" ? <Angle className="size-3.5" /> : key.toUpperCase()}
        title={label} size={key === "size"} rotation={key === "rotation"} precision={2} disabled={!art}
        onChange={value => {
          const state = useCustomArtStore.getState();
          const selected = state.layers.find(layer => layer.imageId === state.selectedId);
          const current = selected?.transform;
          if (!current || !selected) return;
          const transform = key === "size"
            ? { ...current, scaleX: value / 100, scaleY: value / 100 }
            : { ...current, [key]: value };
          dispatchScheduleEvent({ type: "art/setTransform", imageId: selected.imageId, transform }, `art:${selected.imageId}:${key}`);
        }} />,
    }))} />
  );
}
